import React, { useEffect } from "react";
import '../assets/scss/infopanel.scss'

const InfoPanel = () => {

  useEffect(() => { }, []);

	return (
    <div className="info-panel">
      <a href="https://www.instagram.com/konradstudio/" target="_blank" rel="noopener noreferrer" >
        <div className="some instagram anim fade-in"></div>
      </a>
    </div>
  )
}

export default InfoPanel
